import React from 'react'
import styled from 'styled-components'
import { Text } from 'ui'
import { Vicon } from './icons'
import { ToastProps } from './types'

const Container = styled.div<{ isVisible: boolean }>`
position: fixed;
bottom: 24px;
right: 24px;
display: flex;
width: 408px;
padding: 16px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 8px;
border: 1px solid var(--Clean-Borders-Max, #00CC8C);
background: var(--Benefits-Surface-Light, #DCFCE4);
box-shadow: 0 -2px 31px 0 rgba(0, 0, 0, 0.25);
transform: translateY(${props => props.isVisible ? '0' : '100%'});
opacity: ${props => props.isVisible ? '1' : '0'};
transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
`

const TextAndIconContainer = styled.div`
display: flex;
display: flex;
justify-content: flex-end;
align-items: center;
gap: 4px;
`

interface ToastPropsExtended {
  isVisible: boolean
  title: string
  subtitle: string
}

const Toast: React.FC<ToastPropsExtended> = ({ isVisible, title, subtitle }) => {
    return <Container isVisible={isVisible}>
        <TextAndIconContainer>
            <Vicon />
            <Text size="lg" weight="bold" textcolor="#00A471">{title}</Text>
        </TextAndIconContainer>
        <Text>{subtitle}</Text>
    </Container>
}

export default Toast